<twc-popup caption="{{'UPLOAD.LAYER_TYPE_UNKNOWN' | translate}}" type="primary" width="m">
    <twc-popup-content>
        <div class="twc-row twc-mt-2 row-format">
            <div class="twc-col-md-12">
                {{'UPLOAD.LAYER_TYPE_UNKNOWN_NOTICE' | translate}}
            </div>
        </div>
        <div class="twc-row twc-mt-2 row-format" *ngFor="let group of groupedErrorFiles">
            <div class="twc-col-md-12">
                <div class="twc-body font-bold"><b>{{group.errorKey | translate}}</b></div>
            </div>
            <div class="twc-col-md-12">
                <twc-list>
                    <twc-list-item *ngFor="let file of group.filesError">
                        <div class="twc-list-item-col-1 twc-body">
                            {{file.name}}
                        </div>
                    </twc-list-item>
                </twc-list>
            </div>
        </div>
    </twc-popup-content>
    <twc-popup-footer>
        <button class="twc-button twc-button-primary"
            (click)="popupNotValidFilesService.closePopupNotValidFiles()">{{'GENERAL.OK' |
            translate}}</button>
    </twc-popup-footer>
</twc-popup>